module.exports = "/images/heart.svg?3f4beaa3f5f8844b0e2de60848e119c7";